export interface FeatureFlag {
  id: number;
  name: string;
  on: boolean;
  // New parameters must be optional or nullable
}

export enum FeatureFlagsEnum {
  activity_log = 'platform.activity_log',
  admin_email_verification = 'streams.admin_email_verification',
  content_speakers = 'streams.content_manager_speaker',
  navbar_v2 = 'streams.navbar_v2',
  session_details_v2 = 'streams.session_details_v2',
  translations_v3 = 'streams.translations_v3',
  video_v2 = 'streams.video_v2',
  google_meet_phase_1 = 'streams.meet_powered_breakouts_phase_1',
  integrations_ui_q3_2023 = 'streams.integrations_ui_q3_2023',
  audience_list_ui_q3_2023 = 'streams.audience_list_ui_q3_2023',
  metrics_api = 'streams.metrics_api',
  registration_v2_q1_2024 = 'streams.registration_v2_q1_2024',
  go_to_greenroom_for_all_broadcast_types = 'streams.go_to_greenroom_for_all_broadcast_types',
  recording_requires_jwt = 'streams.recording_requires_jwt',
  integrations_confirmation_urls = 'streams.integrations_confirmation_urls',
  color_palettes = 'streams.color_palettes',
  admin_privileges = 'platform.admin_privileges',
  unified_auth = 'platform.unified_auth',
  domain_based_sso = 'platform.domain_based_sso',
  password_gating = 'platform.password_gating',
  // platform-4 flags
  template_library = 'platform.template_library',
  preview_template = 'platform.preview_template',
  create_wizard = 'platform.create_wizard',
  sso_attr_mapping_2025 = 'platform.sso_attr_mapping_2025',

  // project-level flags
  liveblocks_integration = 'platform.liveblocks_integration',

  // tests namespace does not make it into the database, these are local only
  test_oidc_auth = 'tests.test_oidc_auth',
  all_recording_download_requests_fail = 'tests.all_recording_download_requests_fail',
  ui_ai_captions = 'platform.ui_ai_captions',

  series = 'platform.series',
  ai_email = 'platform.ai-email',

  project_title_sync = 'platform.project_title_sync',

  registration_disable_removal = 'platform.registration_disable_removal',

  audiences_enabled = 'platform.audiences_enabled',

  live_monitor = 'platform.live_monitor',
}

export type FeatureFlagMap = {
  [key in FeatureFlagsEnum]?: boolean;
};

export type FeatureFlagState = {
  featureFlags: FeatureFlagMap;
  loading: boolean;
};

export const BetaFlagOptions: FeatureFlagsEnum[] = [];
